// components/PreSaveSection.tsx
// (pode renomear depois para SpotifyReleaseSection)

export default function PreSaveSection({ spotifyUrl }: { spotifyUrl: string }) {
  return (
    <section className="relative w-full py-20 px-6 bg-black overflow-hidden">
      {/* Glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-800/20 via-emerald-600/10 to-transparent opacity-70 pointer-events-none" />

      <div className="max-w-5xl mx-auto relative z-0 grid md:grid-cols-2 gap-12 items-center">
        
        {/* Album cover */}
        <div className="flex justify-center">
          <img
            src="/cover.png"
            alt="Reggae I Wanna Album Cover"
            className="w-64 h-64 rounded-xl shadow-[0_0_30px_rgba(16,185,129,0.5)] object-cover"
          />
        </div>

        {/* Texto */}
        <div className="text-center md:text-left space-y-5">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white">
            Reggae I Wanna — já disponível no Spotify
          </h2>

          <p className="text-zinc-300 text-lg leading-relaxed">
            O novo álbum de{" "}
            <span className="text-emerald-400 font-semibold">NightReggaeX</span>{" "}
            já está no ar.  
            Aperte o play e <em>caia no reggae</em>. 💿
          </p>

          <a
            href={spotifyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full 
            bg-green-500 text-black font-semibold text-lg hover:bg-green-400 
            transition shadow-[0_0_25px_rgba(34,197,94,0.6)]"
          >
            🎧 Ouvir no Spotify
          </a>

          <p className="text-xs text-zinc-500">
            Disponível no Spotify • YouTube Music • Apple Music
          </p>
        </div>
      </div>
    </section>
  );
}
